const isDingDingResult = navigator.userAgent.toLowerCase().indexOf("dingtalk") > -1;

//判断钉钉环境就映入sdk
if (isDingDingResult) {
  document.writeln(
    '<script src="https://appx/web-view.min.js"' + ">" + "<" + "/" + "script>"
  );
}

// 是否在钉钉环境
export function isDingDing() {
    return isDingDingResult
}
